export default __webpack_public_path__ + "static/media/cubism.7485e243.png";